import React, { useEffect, useState } from 'react';
import { ShoppingBag, X } from 'lucide-react';
const SALES_DATA = [{
  name: 'Valentina G.',
  location: 'Buenos Aires'
}, {
  name: 'Lucía M.',
  location: 'Córdoba'
}, {
  name: 'Sofía R.',
  location: 'Rosario'
}, {
  name: 'Camila T.',
  location: 'Mendoza'
}, {
  name: 'Martina P.',
  location: 'La Plata'
}, {
  name: 'Florencia A.',
  location: 'Mar del Plata'
}, {
  name: 'Agustina L.',
  location: 'Tucumán'
}, {
  name: 'Carolina B.',
  location: 'Salta'
}, {
  name: 'Natalia F.',
  location: 'Buenos Aires'
}, {
  name: 'Daniela H.',
  location: 'Mendoza'
}];
function getTimeAgo() {
  const options = ['hace 2 min', 'hace 5 min', 'hace 8 min', 'hace 12 min', 'hace 3 min', 'hace 7 min'];
  return options[Math.floor(Math.random() * options.length)];
}
function getInitials(name: string) {
  return name.split(' ').map(n => n[0]).join('').slice(0, 2);
}
export function SaleNotification() {
  const [visible, setVisible] = useState(false);
  const [current, setCurrent] = useState(SALES_DATA[0]);
  const [timeAgo, setTimeAgo] = useState('hace 3 min');
  const [animating, setAnimating] = useState(false);
  const showNotification = () => {
    const random = SALES_DATA[Math.floor(Math.random() * SALES_DATA.length)];
    setCurrent(random);
    setTimeAgo(getTimeAgo());
    setAnimating(false);
    setVisible(true);
    // Auto-dismiss after 5 seconds
    setTimeout(() => {
      setAnimating(true);
      setTimeout(() => setVisible(false), 400);
    }, 5000);
  };
  useEffect(() => {
    // Show first notification after 4 seconds
    const initialTimer = setTimeout(showNotification, 4000);
    // Then every 30 seconds
    const interval = setInterval(showNotification, 30000);
    return () => {
      clearTimeout(initialTimer);
      clearInterval(interval);
    };
  }, []);
  const dismiss = () => {
    setAnimating(true);
    setTimeout(() => setVisible(false), 400);
  };
  if (!visible) return null;
  return <div className={`fixed bottom-6 left-4 z-50 max-w-[320px] w-[calc(100vw-2rem)] md:w-80 transition-all duration-400 ease-out ${animating ? 'opacity-0 translate-x-[-20px]' : 'opacity-100 translate-x-0'}`} style={{
    animation: animating ? undefined : 'slideInLeft 0.4s ease-out forwards'
  }} data-id="element-311">
      <style data-id="element-312">{`
        @keyframes slideInLeft {
          from { opacity: 0; transform: translateX(-24px); }
          to { opacity: 1; transform: translateX(0); }
        }
      `}</style>

      <div className="bg-white rounded-2xl shadow-[0_8px_32px_rgba(0,0,0,0.12)] border border-stone-100 p-4 flex items-center gap-3 relative" data-id="element-313">
        {/* Avatar */}
        <div className="w-10 h-10 rounded-full bg-stone-900 text-white flex items-center justify-center font-bold text-sm flex-shrink-0" data-id="element-314">
          {getInitials(current.name)}
        </div>

        {/* Content */}
        <div className="flex-1 min-w-0" data-id="element-315">
          <p className="text-xs text-stone-500 mb-0.5 flex items-center gap-1" data-id="element-316">
            <ShoppingBag className="w-3 h-3 text-emerald-600" data-id="element-317" />
            Compra reciente
          </p>
          <p className="text-sm font-bold text-stone-900 truncate" data-id="element-318">
            {current.name}
          </p>
          <p className="text-xs text-stone-500" data-id="element-319">
            compró{' '}
            <span className="text-emerald-700 font-semibold" data-id="element-320">
              Semana Resuelta
            </span>{' '}
            · {timeAgo}
          </p>
        </div>

        {/* Dismiss */}
        <button onClick={dismiss} className="absolute top-2 right-2 text-stone-300 hover:text-stone-500 transition-colors" aria-label="Cerrar" data-id="element-321">
          <X className="w-3.5 h-3.5" data-id="element-322" />
        </button>

        {/* Gold accent bar */}
        <div className="absolute left-0 top-3 bottom-3 w-1 bg-amber-400 rounded-r-full" data-id="element-323"></div>
      </div>
    </div>;
}